<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Administração"
            description="Configurações necessárias"
            url="/dashboard"
            :enabledModalInformacao="false"
            :enabledIframeModalInformacao="false"
            urlIframeModalInformacao=""
            pageIdentifier="administracao"
            :enableBadgeModalInformacao="
              Number($store.state.permissoesRaw?.administracao_ajuda || 0) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.administracao_ajuda || 0
            "
            keyAjudaModalInformacao="administracao_ajuda"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link v-if="item != false" :to="item.link">
            <div class="item">
              <span
                v-if="$store.getters.getQuantidadeAjuda(item.key) > 0"
                class="item-badge"
              >
                {{ $store.getters.getQuantidadeAjuda(item.key) }}
              </span>

              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img
                v-else-if="item.imagem !== ''"
                :src="item.imagem !== '' ? item.imagem : ''"
                alt=""
              />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { mapState } from 'vuex'
import EstabelecimentosEquipesServicosIcon from '@/components/icons/Administracao/EstabelecimentosEquipesServicosIcon.vue'
import SistemasExternosIcon from '@/components/icons/Administracao/SistemasExternosIcon.vue'
import GerenciarUsuariosIcon from '@/components/icons/Administracao/GerenciarUsuariosIcon.vue'
import GerenciarPermissoesIcon from '@/components/icons/Administracao/GerenciarPermissoesIcon.vue'

export default {
  name: 'AdministracaoIndex',
  metaInfo: {
    title: 'Administração',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    EstabelecimentosEquipesServicosIcon,
    SistemasExternosIcon,
    GerenciarUsuariosIcon,
    GerenciarPermissoesIcon,
  },
  computed: {
    ...mapState(['id_funcao']),
    cards() {
      const cards = this.$store.state?.permissoes?.administracao
      let data = cards.map((element) => {
        if (
          this.$store.state.infoMunicipio.exibe_logoefb == '1' &&
          element.key == 'gerenciar_logotipo'
        ) {
          return false
        }

        if (
          this.$store.state.cod_ibge == '1111111' &&
          (element.key == 'gerenciar_brasao' ||
            element.key == 'gerenciar_logotipo')
        ) {
          return false
        }
        return {
          ...element,
        }
      })
      return data.filter((el) => el != false).sort((a, b) => a.ordem - b.ordem)
    },
  },
  data() {
    return {}
  },
}
</script>

<style>
.link {
  border: 0;
  display: block;
  width: 100%;
  font-size: 14px;
  padding: 0 60px 0 20px;
  font-weight: 400;
  color: #999;
  border-radius: 3px;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  padding: 15px;
  margin-top: 20px;
}
.link b {
  color: #000;
}
.step iframe {
  margin: 20px auto;
  display: block;
}

@media (max-width: 768px) {
  .step iframe {
    width: 100% !important;
  }
  .link {
    margin-bottom: 0px;
  }
  .link a {
    word-break: break-all;
  }
}
</style>
